// extracted by mini-css-extract-plugin
export default {"checkbox":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelCheckout-GiftCard-css-module__checkbox--gzsko"};